import { loader } from 'graphql.macro';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useNotificationContext } from '../context/notification-context';
import { PriceRangesGroupType } from '../definitions.d';

const CREATE_PRICE_RANGES_GROUP_MUTATION = loader(
  '../graphql/createPriceRangesGroup.graphql'
);

interface Response {
  createPriceRangesGroup: (priceRangesGroup: PriceRangesGroupType) => void;
  loading?: boolean;
  error?: Error;
}

const useCreatePriceRangesGroupMutation = (companyUuid: string): Response => {
  const { t } = useTranslation();
  const { showNotification } = useNotificationContext();
  const navigate = useNavigate();

  const [mutation, { loading, error }] = useMutation(
    CREATE_PRICE_RANGES_GROUP_MUTATION,
    {
      onError: (e) => {
        showNotification(e.message, 'error');
      },
      onCompleted: () => {
        showNotification(
          t('Price ranges group created successfully'),
          'success'
        );
        navigate(`/companies/${companyUuid}/price-ranges`);
      }
    }
  );

  return {
    loading,
    error,
    createPriceRangesGroup: (priceRangesGroup: PriceRangesGroupType): void => {
      mutation({
        variables: { ...priceRangesGroup, companyUuid }
      });
    }
  };
};

export default useCreatePriceRangesGroupMutation;
